import snakeCase from 'lodash/snakeCase';
import { dateStringToDate } from '@/utils/dates';
import prependPrefix from '@/utils/prependPrefix';
import type FilterParams from '../types/FilterParams';

const parseFilterParams = <FiltersType = Record<string, unknown>>(
  filterParams: FilterParams,
  urlSearch: URLSearchParams,
  prefix?: string,
) =>
  Object.entries(filterParams).reduce(
    (query, [param, { defaultValue = null, type = String }]) => {
      let value;
      const valueFromSearch = urlSearch.get(
        snakeCase(prependPrefix(param, prefix)),
      );
      switch (type) {
        case Array:
          value = valueFromSearch
            ? valueFromSearch.split(',').filter(Boolean)
            : defaultValue;
          break;
        case Boolean:
          value = valueFromSearch ? valueFromSearch === 'true' : defaultValue;
          break;
        case Date:
          value = valueFromSearch
            ? dateStringToDate(valueFromSearch)
            : defaultValue;
          break;
        case JSON:
          value = valueFromSearch ? JSON.parse(valueFromSearch) : defaultValue;
          break;
        case Number:
          value = valueFromSearch ? +valueFromSearch : defaultValue;
          break;
        case String:
        default:
          value = valueFromSearch ?? defaultValue;
          break;
      }
      return {
        ...query,
        [param]: value,
      };
    },
    {},
  ) as FiltersType;

export default parseFilterParams;
